import useScrollAnimation from "@/hooks/useScrollAnimation";
import { partnersData } from "@/mocks/homeData";

export default function PartnersSection() {
  const { ref, isVisible } = useScrollAnimation(0.12);

  return (
    <section id="partners" className="w-full py-16 md:py-24 bg-background-100">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {partnersData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {partnersData.headline}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {partnersData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto">
          {partnersData.partners.map((partner) => (
            <div
              key={partner.name}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all text-center"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto rounded-lg bg-primary-50 flex items-center justify-center mb-3">
                <i className={`${partner.icon} text-lg md:text-xl text-primary-500`} />
              </div>
              <div className="text-xs md:text-sm font-semibold text-foreground-900 leading-tight mb-1">
                {partner.name}
              </div>
              <div className="text-xs text-primary-600 font-medium">
                {partner.tier}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}